import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpParamsHelpersService } from '@zaoblako/web/core/services/http-params-helpers.service';
import { inject, Injectable } from '@angular/core';
import { DeepPartial } from '@zaoblako/web/core/types/deep-partial';
import { Observable } from 'rxjs';

@Injectable()
export class BaseService {
  protected http = inject(HttpClient);
  protected httpParamsHelpersService = inject(HttpParamsHelpersService);
  protected baseUrl: string;
  protected numberPrefix: string = 'FRM';

  public find<T>(options?: any): Observable<T[]> {
    return this.http.get<T[]>(this.baseUrl, {
      params: options ? this.objectToHttpParams(options) : {}
    });
  }

  public findById<T>(id: number | string, options?: any): Observable<T> {
    return this.http.get<T>(this.baseUrl + '/' + id, {
      params: options ? this.objectToHttpParams(options) : {}
    });
  }

  public findByNumber<T>(number: number | string, options?: any): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/${this.numberPrefix}-${number}`, {
      params: options ? this.objectToHttpParams(options) : {}
    });
  }

  public create<T>(model: any): Observable<T> {
    return this.http.post<T>(this.baseUrl, model);
  }

  public update<T, K = void>(model: Partial<T>): Observable<K> {
    return this.http.put<K>(this.baseUrl + '/' + (model as any).id, model);
  }

  public patch<T extends { id?: number | string }, K = void>(model: DeepPartial<T>): Observable<K> {
    return this.http.patch<K>(this.baseUrl + '/' + model.id, model);
  }

  public deleteById<T>(id: number | string, options?: any): Observable<T> {
    return this.http.delete<T>(this.baseUrl + '/' + id, {
      params: options ? this.objectToHttpParams(options) : {}
    });
  }

  public objectToHttpParams(params: Record<string, any>): HttpParams {
    return this.httpParamsHelpersService.objectToHttpParams(params);
  }
}
